import { ITemplateSearchParams } from "../interfaces/API/ITemplateSearchParams";

export class TemplateSearchParams implements ITemplateSearchParams{
  searchTerm: string;
  fileType: string;
  listType: Number;
}